// extracted by mini-css-extract-plugin
export default {"table":"SinglePriceTable_table__4IV1a","row":"SinglePriceTable_row__3x90a"};